export interface PrimaryAble {
  isPrimary: boolean;
}
export function getPrimary<T extends PrimaryAble>(primaryAbles: T[]) {
  const primary = primaryAbles.find(primaryAble => primaryAble.isPrimary);
  return primary || null;
}
